const pages = {
  Unwinding: 'antecipacao',
};

export default pages;
